import { render, staticRenderFns } from "./TheVirtualOffice.vue?vue&type=template&id=4c151864&"
import script from "./TheVirtualOffice.vue?vue&type=script&lang=js&"
export * from "./TheVirtualOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports